import withQuery from 'with-query';

import { Region } from '../shared/types';
import { apiUrl } from './config';
import { getOption, getPromise, RequestOptions } from './utils';

function list(): Promise<any> {
  return getPromise(`${apiUrl}/signal/list`, {}, data => data['signals']);
}

const fetchSignalHistOptions = (
  region: Region,
  signalId: number,
  selectedIndices: number[],
  groupBy: string,
  group: number
): RequestOptions => ({
  url: withQuery(`${apiUrl}/signal/signalHist`, {
    region,
    signalId,
    permutation: selectedIndices.join(','),
    groupBy,
    group,
  }),
  ...getOption(),
});

const fetchSignalDumpOptions = (
  region: Region,
  signalId: number,
  selectedIndices: number[],
  groupBy: string,
  group: number,
  dateStr: string
): RequestOptions => ({
  url: withQuery(`${apiUrl}/signal/signalDump`, {
    region,
    signalId,
    permutation: selectedIndices.join(','),
    groupBy,
    group,
    date: dateStr,
  }),
  ...getOption(),
});

const fetchSignalProbOptions = (
  region: Region,
  signalId: number,
  selectedIndices: number[],
  groupBy: string,
  group: number
): RequestOptions => ({
  url: withQuery(`${apiUrl}/signal/signalProb`, {
    region,
    signalId,
    permutation: selectedIndices.join(','),
    groupBy,
    group,
  }),
  ...getOption(),
});

const fetchNeighborSignalsOptions = (
  region: Region,
  stockCode: string,
  dateStr: string,
  signalId: number,
  permutation: string,
  groupBy: string,
  group: number
): RequestOptions => ({
  url: withQuery(`${apiUrl}/signal/neighborSignals`, {
    region,
    stockCode,
    date: dateStr,
    signalId,
    permutation,
    groupBy,
    group,
  }),
  ...getOption(),
});

export default {
  list,
  fetchSignalHistOptions,
  fetchSignalDumpOptions,
  fetchSignalProbOptions,
  fetchNeighborSignalsOptions,
};
